import React, { useState, useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { setWorkbookProperty, updateCalculatedField } from "./WorkbookSlice";
import { sqlFunctions } from "../smallFunction/sqlFunctions";
import { v4 as uuidv4 } from "uuid";
import { handleUpdateWorkbook } from "./components/WorkbookComponets/HandleUpdateWorkbook";
import SelectBox from "./components/Aside2Components/DropzoneComponents/FilterConfigCompComponents/SelectBox";

const dataTypes = [
  { label: "Number", value: "Number" },
  { label: "String", value: "String" },
  { label: "Boolean", value: "Boolean" },
];

export default function CalculatedFieldModal({
  items,
  closeModal,
  calculatedUUID,
  calculatedFields,
  updateWorkbook,
}) {
  const dispatch = useDispatch();
  const [currentWordInBracket, setCurrentWordInBracket] = useState(false);
  const [suggestions, setSuggestions] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [suggestionPosition, setSuggestionPosition] = useState({
    top: 0,
    left: 0,
  });
  const textareaRef = useRef(null);
  const [fieldData, setFieldData] = useState({
    name: "",
    formula: "",
    dataType: "Number",
  });
  console.log(items);

  const requiredCColumnsArray = items.map((item) => {
    console.log(item);
    if (item) {
      if (item.columnType === "calculatedField") {
        return item.name;
      } else {
        return item.columnName;
      }
    }
  });
  // console.log(items);
  // console.log(requiredCColumnsArray);

  const allSuggestions = [...sqlFunctions, ...requiredCColumnsArray];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFieldData((prevFieldData) => ({
      ...prevFieldData,
      [name]: value,
    }));
  };

  const handleDataTypeChange = (e) => {
    const { value } = e.target;
    setFieldData((prevFieldData) => ({
      ...prevFieldData,
      ["dataType"]: value,
    }));
  };

  const handleTextArea = (e) => {
    const inputText = e.target.value;
    setFieldData((prevFieldData) => ({
      ...prevFieldData,
      formula: inputText,
    }));
    const textarea = textareaRef.current;
    const { selectionStart } = textarea;

    // Extract the last word or the text inside the last brackets if they exist
    const openBracketIndex = inputText.lastIndexOf("(");
    const closeBracketIndex = inputText.lastIndexOf(")");
    console.log(openBracketIndex, closeBracketIndex, selectionStart);

    let lastWord = "";

    if (
      openBracketIndex !== -1 &&
      openBracketIndex < closeBracketIndex &&
      textareaRef.current.selectionStart <= closeBracketIndex
    ) {
      // Get text inside the last open and close brackets
      setCurrentWordInBracket(true);
      lastWord = inputText
        .substring(openBracketIndex + 1, closeBracketIndex)
        .trim();
    } else {
      // Get the last word outside of brackets
      lastWord = inputText.split(" ").pop().trim();
    }

    console.log(lastWord);

    // Filter suggestions based on the extracted last word
    const filteredSuggestions = allSuggestions.filter(
      (item) =>
        item !== undefined &&
        item.toLowerCase().startsWith(lastWord.toLowerCase())
    );

    setSuggestions(filteredSuggestions);

    // Calculate the position for the suggestions

    const textBeforeCursor = inputText.substring(0, selectionStart);
    const linesBeforeCursor = textBeforeCursor.split("\n");
    const currentLine = linesBeforeCursor[linesBeforeCursor.length - 1];

    // Approximate dimensions
    const charWidth = 7; // Approximate character width (in pixels)
    const lineHeight = 10; // Approximate line height (in pixels)

    // Calculate the top and left position of the suggestions dropdown
    const top =
      textarea.offsetTop + linesBeforeCursor.length * lineHeight + lineHeight; // Position below current line
    const left = textarea.offsetLeft + currentLine.length * charWidth; // Position at the end of current line

    setSuggestionPosition({ top, left });
  };

  const handleKeyDown = (e) => {
    const input = e.target;
    if (e.shiftKey && (e.key === "(" || e.key === "{")) {
      e.preventDefault();
      const openBracket = e.key;
      const closeBracket = e.key === "(" ? ")" : "}";
      const cursorPosition = input.selectionStart;
      const updatedText =
        fieldData.formula.substring(0, cursorPosition) +
        openBracket +
        closeBracket +
        fieldData.formula.substring(cursorPosition);
      setFieldData((prevFieldData) => ({
        ...prevFieldData,
        formula: updatedText,
      }));
      setTimeout(() => {
        input.setSelectionRange(cursorPosition + 1, cursorPosition + 1);
      }, 0);

      return;
    }

    if (["/", "+", "-", "*", "=", "_"].includes(e.key)) {
      e.preventDefault(); // Prevent the default behavior of the key
      const cursorPosition = input.selectionStart;
      const updatedText =
        fieldData.formula.substring(0, cursorPosition) +
        e.key +
        " " +
        fieldData.formula.substring(cursorPosition);
      setFieldData((prevFieldData) => ({
        ...prevFieldData,
        formula: updatedText,
      }));
      setTimeout(() => {
        input.setSelectionRange(cursorPosition + 2, cursorPosition + 2); // Move cursor after the space
      }, 0);
      return; // Prevent further processing
    }
    if (e.key === "ArrowDown") {
      e.preventDefault();
      console.log(suggestions);
      setSelectedIndex((prev) => {
        console.log("Previous selected index:", prev);
        return prev < suggestions.length - 1 ? prev + 1 : prev;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedIndex((prev) => (prev > 0 ? prev - 1 : prev));
    } else if (e.key === "Tab") {
      e.preventDefault(); // Default tab behavior ko rok do
      if (suggestions.length > 0) {
        const selectedSuggestion =
          suggestions[selectedIndex !== -1 ? selectedIndex : 0];
        const bracketEnclosedSuggestion = currentWordInBracket
          ? "(" + selectedSuggestion + ")"
          : selectedSuggestion;
        const updatedText =
          fieldData.formula.split(" ").slice(0, -1).join(" ") +
          " " +
          bracketEnclosedSuggestion +
          " ";
        setFieldData((prevFieldData) => ({
          ...prevFieldData,
          formula: updatedText,
        }));
        setCurrentWordInBracket(false);
        setSuggestions([]);
        setSelectedIndex(-1);
      }
    } else if (e.key === "Enter") {
      e.preventDefault();
      const updatedText = fieldData.formula + "\n";
      setFieldData((prevFieldData) => ({
        ...prevFieldData,
        formula: updatedText,
      }));
    }
  };

  useEffect(() => {
    if (calculatedUUID && calculatedFields) {
      const selectedField = calculatedFields.find(
        (field) => field.uuid === calculatedUUID
      );
      if (selectedField) {
        setFieldData({
          name: selectedField.rename || "",
          formula: selectedField.formula || "",
          dataType: selectedField.dataType || "Number",
        });
      }
    }
  }, [calculatedUUID, calculatedFields]);

  const handleTextAreaChange = (e) => {
    const textarea = textareaRef.current;

    // Adjust the height of the textarea to fit its content
    textarea.style.height = "auto"; // Reset height to calculate scrollHeight
    textarea.style.height = `${textarea.scrollHeight}px`;

    // Update the parent form's height dynamically

    handleTextArea(e); // Call the existing change handler
  };

  const handleSaveCalculatedField = () => {
    console.log(fieldData);
    console.log(calculatedFields);

    const calculatedCoumnObject = {
      name: fieldData.name,
      rename: fieldData.name,
      formula: fieldData.formula,
      dataType: fieldData.dataType,
      uuid: calculatedUUID || uuidv4(),
      columnType: "calculatedField",
    };

    console.log(calculatedCoumnObject);
    let updatedCalculatedFields;

    if (calculatedUUID) {
      const indexItem = calculatedFields.findIndex(
        (item) => item.uuid === calculatedUUID
      );

      if (indexItem !== -1) {
        console.log(indexItem);
        updatedCalculatedFields = [...calculatedFields];
        updatedCalculatedFields[indexItem] = {
          ...calculatedFields[indexItem],
          ...calculatedCoumnObject,
        };
        dispatch(
          updateCalculatedField({
            value: calculatedCoumnObject,
            Sheetid: "",
          })
        );
      } else {
        console.warn(calculatedUUID);
        updatedCalculatedFields = [...calculatedFields];
      }
    } else {
      console.log("Adding a new calculated field");
      updatedCalculatedFields = [...calculatedFields, calculatedCoumnObject];
    }
    console.log(updatedCalculatedFields);
    dispatch(
      setWorkbookProperty({
        itemInArray: false,
        key: "calculatedFields",
        value: updatedCalculatedFields,
      })
    );
    closeModal();
    handleUpdateWorkbook(updateWorkbook);
  };
  const handleKeyDownForSaveCalculatedField = (event) => {
    if (event.ctrlKey && event.key === "Enter") {
      handleSaveCalculatedField(); // Call your function here
    }
  };

  return (
    <main
      className="fixed inset-0 flex items-center justify-center z-50"
      onKeyDown={handleKeyDownForSaveCalculatedField}
    >
      <section className="flex flex-col gap-4 relative border rounded shadow-lg bg-white w-[30rem] h-auto">
        <header className="w-full flex items-center justify-between p-1 bg-gray-50 font-medium rounded-t">
          Calculated Column
          <FaTimes className="cursor-pointer" onClick={closeModal} />
        </header>
        <div className="flex flex-col items-center justify-start w-full gap-1">
          <label htmlFor="name" className="w-[98%] font-medium text-left">
            Title:
          </label>
          <input
            type="text"
            id="name"
            value={fieldData.name}
            name="name"
            placeholder="Name"
            className="w-[98%] border rounded px-2 py-1 focus:outline-none"
            onChange={handleInputChange}
          />
        </div>
        <div className="flex flex-col items-center justify-start w-full gap-1">
          <label htmlFor="formula" className="w-[98%] font-medium text-left">
            Formula:
          </label>
          <textarea
            id="formula"
            name="formula"
            ref={textareaRef}
            value={fieldData.formula}
            onChange={handleTextAreaChange}
            onKeyDown={handleKeyDown}
            placeholder="Type your SQL formula here..."
            className="border rounded px-2 py-1 h-auto w-[98%] text-xs font-medium focus:outline-none resize-none"
            style={{ minHeight: "6rem" }}
          />
          {suggestions.length > 0 && (
            <div
              className="absolute z-10 border border-gray-300 rounded bg-white shadow-lg text-xs"
              style={{
                top: suggestionPosition.top,
                left: suggestionPosition.left,
                width: "max-content",
              }}
            >
              {suggestions.map((suggestion, index) => (
                <p
                  key={index}
                  className={`cursor-pointer text-left p-1.5 ${
                    selectedIndex === index ? "bg-gray-200" : "bg-white"
                  }`}
                  onMouseDown={() => {
                    const updatedText =
                      fieldData.formula.split(" ").slice(0, -1).join(" ") +
                      " " +
                      suggestion +
                      " ";
                    setFieldData((prevFieldData) => ({
                      ...prevFieldData,
                      formula: updatedText,
                    }));
                  }}
                >
                  {suggestion}
                </p>
              ))}
            </div>
          )}
        </div>
        <div className="flex flex-col items-center justify-start w-full gap-1">
          <label htmlFor="dataType" className="w-[98%] font-medium text-left">
            Data Type:
          </label>
          <div className="w-[98%] flex items-center justify-start">
            <SelectBox
              optionsArray={dataTypes}
              onChange={handleDataTypeChange}
              value={fieldData.dataType}
            />
          </div>
        </div>
        <div className="flex items-center justify-end p-1 w-full gap-2 bg-gray-50 rounded-b">
          <button
            className="border border-gray-200 p-1 px-3"
            onClick={closeModal}
          >
            Cancel
          </button>
          <button
            className="bg-blue-950 text-white p-1 px-3"
            onClick={handleSaveCalculatedField}
            // onClick={handleSave}
          >
            Save
          </button>
        </div>
      </section>
    </main>
  );
}
